export default __webpack_public_path__ + "d16c9d93dc96e960a78b27e43026b0b4.png";